export const SourceReliabilityNffReport = "reliabilitynffreports";
export const SourceReliabilityMonthlyNff = "reliabilitynffreports/monthlynff";
export const SourceReliabilityTotalNff = "reliabilitynffreports/totalnff";
